
import React, { useState } from "react";
import { useEffect } from "react";
import { SwitchButton } from "../shared/switch-button";
import { useLanguageSelection } from "../../hooks/use-language-selection";
import { useLanguage } from "../../hooks/use-language";

/**
 * Componente que contiene el switch el cual  puede cambiar el idioma del sitio completo entre 'Español' e 'Inglés'.
 * @returns {React.Component} MenuLanguageSelector
 */
export const MenuLanguageSelector = () => {
    const [checked, setChecked] = useState(false);
    const language = useLanguage();
    const langSelection = useLanguageSelection();


    useEffect(()=>{
        setChecked(language === 'en');
    },[language])

    const updateLanguage = (_checked) => {
       langSelection.setLanguage({lang: _checked?'en':'es'});
    }


    return (
        <div className="d-flex align-items-center justify-content-center language-selector-menu">
            <p className={`lang ${!checked ? 'active' : ''}`}>Es</p>
            <div className="px-3  d-flex aling-items-center">
                <SwitchButton onChange={({ checked }) => updateLanguage(checked)} checked={language === 'es' ? false : true} />
            </div>
            <p className={`lang ${checked ? 'active' : ''}`}>Eng</p>
        </div>
    )
}


